import { css, cva } from '@/styled-system/css';

export const menuContentRecipe = cva({
  base: {
    borderRadius: 'obj.soft',
    backgroundColor: 'bg.elevated.mediumShadow',
    boxShadow: 'md',
    position: 'relative',
    overflow: 'hidden',
    minWidth: '200px',
    maxWidth: '360px',
    // Reset browser defaults for <ul>
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  variants: {
    dividers: {
      true: {
        '& .c11n_menu__group:not(:last-child)': {
          borderBottomWidth: 'default',
          borderBottomStyle: 'solid',
          borderBottomColor: 'Menu.Group.border',
        },
      },
      false: {},
    },
  },
});

export const menuContentPositionerStyles = css.raw({
  zIndex: 'menu',
});
